<template>
  <div class="comment-border padding-left-xs grid-y margin-top-s">
    <div
      class="grid-x align-middle margin-bottom-xxs"
    >
      <Username
        v-if="userNickname"
        :user-nickname="userNickname"
        :author-id="authorId"
        :is-employee-author="isEmployeeAuthor"
        class="margin-right-xxs"
      /><span class="text">{{ timeElapsedSinceSubmission }}</span>
    </div>
    <ExpandedReviewComment
      :content="commentText"
    />
    <div>
      <VoteButton
        v-if="!syndicated"
        :id="id"
        :is-comment="true"
        :total-positive-feedback-count="totalPositiveFeedbackCount"
      />
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { getTimeElapsed } from '@utils/getTimeElapsed';
import Username from '@components/reviews/Username';
import ExpandedReviewComment from '@components/reviews/ExpandedReviewComment';
import VoteButton from './VoteButton';

const props = defineProps({
  authorId: {
    type: String,
    required: true,
  },
  commentText: {
    type: String,
    required: true,
  },
  id: {
    type: Number,
    required: true,
  },
  userNickname: {
    type: String,
    required: true,
  },
  submissionTime: {
    type: String,
    required: true,
  },
  syndicated: {
    type: Boolean,
    required: true,
  },
  totalPositiveFeedbackCount: {
    type: Number,
    required: true,
  },
  badgeInfo: {
    type: Object,
    default: () => ({}),
  },
});

const timeElapsedSinceSubmission = getTimeElapsed(props.submissionTime);

const isEmployeeAuthor = computed(() => !!(props.badgeInfo?.Staff));
</script>

<style lang="scss" scoped brand="bcom">
@import "~settingSCSS";
@import "@core/csg/src/scss/typography/typography-mixins.scss";

.text {
  @include body(small);
}
</style>
<style lang="scss" scoped brand="mcom">
@import "~settingSCSS";
@import "@core/csg/src/scss/typography/typography-mixins.scss";

.text {
  @include body(body);
}
</style>

<style lang="scss" scoped>
@import "~settingSCSS";

.comment-border {
  border-left: $gray-3-border;
}
</style>
